import { FC } from 'react';
import { OrderStatus } from '@/features/orders/types/orders-dto';
import { ordersUtils } from '@/features/orders/utils/ordersUtils';

type Props = {
	status: OrderStatus;
};

const OrdersStatusDetails: FC<Props> = ({ status }) => {
	const { label, icon: Icon, iconStyles } = ordersUtils.getStatusData(status);

	return (
		<div className='flex items-center gap-1.5'>
			<Icon className={iconStyles} />
			<label className={'text-popover-800'}>{label}</label>
		</div>
	);
};

export default OrdersStatusDetails;
